import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VCharts from 'v-charts'

import './assets/css/reset.less'
import moment from 'moment'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss'

import loading from './components/loading/loading.js'
import Hls from "hls.js";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import directive from './utils/directives'

window.Hls = Hls

Vue.use(directive)
Vue.use(VueQuillEditor);
Vue.use(VCharts)
Vue.use(loading)
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
